import type { EmailStarterTemplate } from '../types'

/**
 * "Here's your promo code" — simple reward delivery with a clear unlock CTA.
 * The code itself is rendered as a prominent call-out block using a styled
 * heading so it reads well in every client.
 */
export const promoCodeStarter: EmailStarterTemplate = {
    id: 'promo-code-classic',
    label: 'Promo code delivery',
    description: 'Welcomes customer, shows the code prominently, sends them shopping.',
    icon: 'Gift',
    accent: '#db2777',
    defaultSubject: 'A little something for you, {{ customerFirstName }}',
    defaultPreheader: 'Your promo code is inside — valid for a limited time.',
    doc: {
        type: 'doc',
        content: [
            {
                type: 'heading',
                attrs: { level: 1, textAlign: 'left' },
                content: [{ type: 'text', text: 'A little something for you' }],
            },
            {
                type: 'paragraph',
                content: [
                    { type: 'text', text: 'Hi ' },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'customerFirstName',
                            label: 'customerFirstName',
                            fallback: 'there',
                            required: false,
                        },
                    },
                    {
                        type: 'text',
                        text: ', to say thank you we unlocked a promo code for your next order:',
                    },
                ],
            },
            {
                type: 'heading',
                attrs: { level: 2, textAlign: 'center' },
                content: [
                    {
                        type: 'text',
                        marks: [{ type: 'bold' }],
                        text: 'Use code ',
                    },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'promoCode',
                            label: 'promoCode',
                            fallback: '',
                            required: true,
                        },
                    },
                ],
            },
            {
                type: 'paragraph',
                attrs: { textAlign: 'center' },
                content: [
                    {
                        type: 'text',
                        marks: [{ type: 'italic' }],
                        text: 'Apply it at checkout — it is all yours.',
                    },
                ],
            },
            {
                type: 'emailButton',
                attrs: {
                    text: 'Start shopping',
                    url: '{{ storeUrl }}',
                    align: 'center',
                    variant: 'filled',
                    radius: 'round',
                    bgColor: '#db2777',
                    textColor: '#ffffff',
                },
            },
            { type: 'emailSpacer', attrs: { height: 16 } },
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: 'Code expires soon. If you run into any issues, just reply to this email and we will sort it.',
                    },
                ],
            },
        ],
    },
}
